import InstrumentPreservePrecisionTableCell from './InstrumentPreservePrecisionTableCell';

export default InstrumentPreservePrecisionTableCell;
